import { Flexbox, Text } from '@morressier/ts';
import { FaSearch } from 'react-icons/fa';
import { Container } from './style';

interface IHomeSearchNoResultsProps {
  searchTerm: string;
}

const HomeSearchNoResults = (props: IHomeSearchNoResultsProps): JSX.Element => {
  const { searchTerm } = props;
  return (
    <Container>
      <Flexbox
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        style={{ height: '100%' }}
      >
        <FaSearch size="32px" />
        <Text size="h3_new">No results for </Text>
        <Text size="h3_new">“{searchTerm.trim()}”.</Text>
        <Text size="body2_new">
          We couldn’t find anything, try again with a different term.
        </Text>
      </Flexbox>
    </Container>
  );
};

export default HomeSearchNoResults;
